import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from "ngx-toastr";

@Injectable({
  providedIn: 'root'
})
export class NotifyService {
  constructor(private toastr: ToastrService,private translate: TranslateService,) {}

  showSuccess(message, title) {
    this.toastr.success(message, title);
  }

  showError(message, title) {
    console.log('why here');
    this.toastr.error(message, title);
  }

  showInfo(message, title) {
    this.toastr.info(message, title);
  }

  showWarning(message, title) {
    this.toastr.warning(message, title);
  }
}
